import React from "react";
import { create } from "jss";
import jssPreset from '@mui/styles/jssPreset';
import Routes from "./routes/RoutesProvider";
import ReloadPrompt from "./components/general/ReloadPrompt";


const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById("jss-insertion-point"),
});

function App() {
  return (
    <>
      <Routes />
      <ReloadPrompt />
    </>
  );
}

export default App;
